import React, { FunctionComponent } from 'react';
import Svg from '../../../core/icons/Svg';
import { useTheme } from '../../../core/hooks';

export interface ProfileIconProps {
  active?: boolean;
  completed?: boolean;
}

const ProfileIcon: FunctionComponent<ProfileIconProps> = ({
  active,
  completed,
  ...rest
}: ProfileIconProps) => {
  const theme = useTheme();
  let fillColor = '';
  let accentFillColor = '';
  if (active) {
    fillColor = theme.colors.primary;
    accentFillColor = theme.colors.tertiary;
  } else if (completed) {
    fillColor = theme.colors.primary;
    accentFillColor = theme.colors.primary;
  } else {
    fillColor = theme.colors.borderGray;
    accentFillColor = theme.colors.borderGray;
  }

  return (
    <Svg
      width="22px"
      height="27px"
      viewBox="0 0 22 27"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...rest}
    >
      <title>Profile Icon</title>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Complete-Profile"
          transform="translate(-709.000000, -216.000000)"
          fillRule="nonzero"
        >
          <g id="Group" transform="translate(505.000000, 209.000000)">
            <g id="Group-2" transform="translate(204.000000, 7.000000)">
              <path
                d="M14.960484,18.3678545 C15.428556,18.3678545 15.807528,18.7495855 15.807528,19.2208582 C15.807528,19.6921309 15.428556,20.0738618 14.960484,20.0738618 L6.393816,20.0738618 C5.925744,20.0738618 5.545584,19.6921309 5.545584,19.2208582 C5.545584,18.7495855 5.925744,18.3678545 6.393816,18.3678545 L14.960484,18.3678545 Z M15.781392,13.7729455 C15.956028,14.0545309 15.956028,14.4103418 15.781392,14.6919273 C15.606756,14.9711564 15.287184,15.1266764 14.960484,15.0913309 L6.393816,15.0913309 C5.959008,15.0418473 5.629932,14.6730764 5.629932,14.2324364 C5.629932,13.7917964 5.959008,13.4218473 6.393816,13.3735418 L14.960484,13.3735418 C15.287184,13.3381964 15.606756,13.4937164 15.781392,13.7729455 Z"
                id="Combined-Shape"
                fill={accentFillColor}
              ></path>
              <path
                d="M10.692,1.33226763e-14 C12.4901029,1.33226763e-14 13.7430722,0.741570392 14.292079,2.16728542 L14.292079,2.16728542 L14.364108,2.37285818 L16.1568,2.37374697 C16.799792,2.37374697 17.3291563,2.85622446 17.3968804,3.4760432 L17.3968804,3.4760432 L17.4042,3.61083788 L17.404,3.904 L17.591467,3.95988303 C19.9817025,4.71662588 21.3563298,6.73715922 21.384,9.67522909 L21.384,19.8771055 C21.384,23.7144436 19.107792,26.0142545 15.281244,26.0142545 L6.103944,26.0142545 C5.614488,26.0142545 5.14998,25.9765527 4.712796,25.9023273 L4.453812,25.8540218 C1.637064,25.2731782 9.76996262e-14,23.1336 9.76996262e-14,19.8771055 L9.76996262e-14,9.76594909 C9.76996262e-14,9.37243636 0.02376,8.99541818 0.07128,8.63489455 C0.392286581,6.18566959 1.77864282,4.52814724 3.97837872,3.90455988 L3.9798,3.61083788 C3.9798,2.92761144 4.53828,2.37374697 5.2272,2.37374697 L5.2272,2.37374697 L6.79536,2.37285818 L6.80894809,2.34095449 C7.44285725,0.872277678 8.68995908,0.0777657777 10.4276779,0.00542831063 L10.4276779,0.00542831063 Z M3.98694374,5.69894831 L4.05063233,5.67200779 C2.49353444,6.25741065 1.707156,7.62769104 1.707156,9.76594909 L1.707156,19.8771055 C1.707156,22.8096 3.186216,24.2976436 6.103944,24.2976436 L15.270552,24.2976436 C18.187092,24.2976436 19.656648,22.8096 19.656648,19.8771055 L19.656648,9.76594909 C19.656648,7.66264067 18.9006552,6.30241004 17.3969982,5.70134184 C17.2856366,7.32132476 15.9258557,8.60072727 14.2647641,8.60072727 L14.2647641,8.60072727 L7.1192359,8.60072727 C5.45711937,8.60072727 4.09668542,7.31974541 3.98694374,5.69894831 Z M10.692,1.53163636 C9.35118082,1.53163636 8.56394418,2.03218249 8.16700052,3.09755431 C7.98583074,3.58301494 7.51907194,3.90538334 6.99706556,3.90538334 L6.99706556,3.90538334 L5.5242,3.90449455 L5.5242,5.48723712 C5.5242,6.30948063 6.15677857,6.98519854 6.9656233,7.06184963 L6.9656233,7.06184963 L7.1192359,7.06909091 L14.2647641,7.06909091 C15.1456781,7.06909091 15.8598,6.36087085 15.8598,5.48723712 L15.8598,5.48723712 L15.8598,3.90449455 L14.1422647,3.90538332 C13.6230913,3.90528238 13.1636794,3.58723674 12.9795077,3.11586295 L12.9795077,3.11586295 L12.8853325,2.81389899 C12.5902884,1.93809082 11.9171668,1.53163636 10.692,1.53163636 Z"
                id="Combined-Shape"
                fill={fillColor}
              ></path>
            </g>
          </g>
        </g>
      </g>
    </Svg>
  );
};

export default ProfileIcon;
